import React from 'react'
import {useAppSelector} from 'store'
import {LANGS} from 'src/lib/translates/consts'
import {isMobileUserAgent} from 'services/app'
import {getLang} from 'store/translates/selectors'
import type {CallbackType} from 'store/modal/entities'
import startru from 'src/img/startru.png'
import starten from 'src/img/starten.png'
import startuk from 'src/img/startuk.png'
import starttr from 'src/img/starttr.png'
import {StartGameMobileButton} from '../StartGameMobileButton'
import styles from './startpage.scss'


export const StartPage = () => {
  const currentLang = useAppSelector(getLang)
  const isMobile = isMobileUserAgent()
  const handleClose = (callback: CallbackType) => callback?.()

  return <div className={styles.gamearea}>
    {currentLang === LANGS.RU && <img src={startru} />}
    {currentLang === LANGS.EN && <img src={starten} />}
    {currentLang === LANGS.UK && <img src={startuk} />}
    {currentLang === LANGS.TR && <img src={starttr} />}
    {isMobile && <StartGameMobileButton onClick={handleClose} />}
  </div>
}
